<template>
  <v-expansion-panels style="margin-top: .5%;">
    <v-expansion-panel key="FV">
      <v-expansion-panel-header>{{ selectV }}</v-expansion-panel-header>
      <v-expansion-panel-content>
        <filter-vehicles></filter-vehicles>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-expansion-panel key="CM">
      <v-expansion-panel-header>{{ settingscommand }}</v-expansion-panel-header>
      <v-expansion-panel-content>
        <command-list></command-list>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import i18n from "@/plugins/i18n";

export default {
  name: "commands",
  components: {
    filterVehicles: () => import("@/components/filterVehicles"),
    commandList: () => import("@/components/commandsList"),
  },
  data() {
    return {
      message: "Configuración de comandos",
      panel: [true, false],
      selectV: "",
      settingscommand: "",
      local: "",
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.local = i18n.locale;
    //this.$store.commit('setTitle', "Comandos")
    this.$store.commit("setTitle", "ALERTRUCK");
    this.$store.commit("setPageHeader", [
      this.$t("commands"),
      "",
      "",
      "",
      true,
    ]);
    this.settingscommand = this.$t("commandSetting").toUpperCase();
    this.selectV = this.$t("selectV").toUpperCase();

    // this.selectV =
    //   this.local == "es"
    //     ? this.selectV.substr(0, 20).toUpperCase()
    //     : this.selectV.substr(0, 14).toUpperCase();
  },
};
</script>

<style scoped></style>
